import { Facebook, MessageCircle, Linkedin, Twitter, Copy } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ url, title, summary, className = "" }) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title || "");
  const s = encodeURIComponent(summary || title || "");

  const links = [
    {
      key: "facebook",
      label: "Facebook",
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
      bg: "#1877F2",
    },
    {
      key: "whatsapp",
      label: "WhatsApp",
      icon: MessageCircle,
      // wa.me works on mobile + desktop
      href: `https://wa.me/?text=${t}%20${u}`,
      bg: "#25D366",
    },
    {
      key: "linkedin",
      label: "LinkedIn",
      icon: Linkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
      bg: "#0A66C2",
    },
    {
      key: "twitter",
      label: "X (Twitter)",
      icon: Twitter,
      href: `https://twitter.com/intent/tweet?url=${u}&text=${s}`,
      bg: "#000000",
    },
  ];

  const copy = () => {
    navigator.clipboard.writeText(url);
    toast.success("Link copied");
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="share-buttons">
      {links.map(({ key, label, icon: Icon, href, bg }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded text-white transition-opacity hover:opacity-90"
          style={{ background: bg }}
          data-testid={`share-${key}-btn`}
          title={`Share on ${label}`}
        >
          <Icon className="w-3.5 h-3.5" /> {label}
        </a>
      ))}
      <button
        onClick={copy}
        className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded transition-colors"
        style={{ background: "var(--bf-surface)", border: "1px solid var(--bf-border)" }}
        data-testid="share-copy-btn"
      >
        <Copy className="w-3.5 h-3.5" /> Copy link
      </button>
    </div>
  );
}
